/**
 * IA visual: a cliente manda foto ("tem esse?") e a vendedora recebe as
 * possíveis correspondências no estoque do ERP. Não vai para a cliente.
 */
import type { ProdutoErp } from "./erp";

/** Em ordem de prioridade. */
export const NIVEIS_CORRESPONDENCIA = [
  "exata",
  "semelhante",
  "mesma_categoria",
  "alternativa",
] as const;
export type NivelCorrespondencia = (typeof NIVEIS_CORRESPONDENCIA)[number];

export const ROTULO_NIVEL: Record<NivelCorrespondencia, string> = {
  exata: "Possível correspondência",
  semelhante: "Parecido",
  mesma_categoria: "Mesma categoria",
  alternativa: "Alternativa",
};

export interface DescricaoPeca {
  /** A foto mostra uma peça de roupa/acessório? */
  ehProduto: boolean;
  /** Comprovante de pagamento (PIX, transferência, boleto pago). */
  comprovante?: boolean;
  tipo: string;
  categoria: string;
  cores: string[];
  estampa: string | null;
  caracteristicas: string[];
  /** Uma frase para a vendedora. */
  resumo: string;
}

export interface CorrespondenciaProduto {
  nivel: NivelCorrespondencia;
  /** 0 a 100. */
  confianca: number;
  motivo: string;
  /** Retrato do produto no momento da análise (estoque pode ter mudado). */
  produto: ProdutoErp;
}

export interface IdentificacaoProduto {
  interacaoId: string;
  mensagemId: string;
  descricao: DescricaoPeca | null;
  correspondencias: CorrespondenciaProduto[];
  erro: string | null;
  criadoEm: string;
}

export interface EstadoVisao {
  disponivel: boolean;
  identificacoes: IdentificacaoProduto[];
  /** Fotos sendo analisadas agora. */
  analisando: string[];
}

export function rotuloConfianca(c: number): "Alta" | "Média" | "Baixa" {
  return c >= 75 ? "Alta" : c >= 45 ? "Média" : "Baixa";
}
